import { Controller } from '@hotwired/stimulus';
import callApi from '../common/AjaxUtil';

export default class extends Controller {
  static targets = [];
  static values = {};

  #form;

  connect(){
    this.#form = this.element;
    this.#form.addEventListener('submit', event=>{
      event.preventDefault();
      this.submit(event);
    })
  }

  submit(submitEvent){
    submitEvent.preventDefault();
    const requestBody = {};
    const formData = new FormData(this.#form);
    let method = this.#form.getAttribute('method');
    for(const pair of formData.entries()){
      const formKey = pair[0];
      if(formKey === '_method'){
        method = pair[1];
        continue;
      }
      requestBody[formKey] = pair[1];
    }
    const url = this.#form.getAttribute('action');
    console.log(method, url, requestBody);
    // return;
    callApi(url, method, requestBody)
    .then(()=>{
      window.$sendNotice('저장되었습니다.');
    }).catch(err=>{
      window.$sendAlert(err.msg);
    })
  }

}
